/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersImportJobLogsResponse } from '../../models/users-import-job-logs-response';

export interface GetUsersImportJobLogs$Params {
  'Active-Tenant-Identifier': string;
  jobId: string;
}

export function getUsersImportJobLogs(http: HttpClient, rootUrl: string, params: GetUsersImportJobLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportJobLogsResponse>> {
  const rb = new RequestBuilder(rootUrl, getUsersImportJobLogs.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('jobId', params.jobId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsersImportJobLogsResponse>;
    })
  );
}

getUsersImportJobLogs.PATH = '/users-import/{jobId}/logs';
